exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content {\n  padding: 10px;\n}\n\n.content img {\n  max-width: 100%;\n}\n\n.markdown-text p,.preview p {\n  white-space: pre-wrap;\n  white-space: -moz-pre-wrap;\n  white-space: -pre-wrap;\n  white-space: -o-pre-wrap;\n  word-wrap: break-word;\n  line-height: 2em;\n  margin: 1em 0\n}\n\n.markdown-text>:first-child,.preview>:first-child {\n  margin-top: 0\n}\n\n.markdown-text>:last-child,.preview>:last-child {\n  margin-bottom: 1em\n}\n\n.markdown-text li,.preview li {\n  font-size: 14px;\n  line-height: 2em\n}\n\n.markdown-text li code,.markdown-text p code,.preview li code,.preview p code {\n  color: #000;\n  background-color: #fcfafa;\n  padding: 4px 6px\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/article.vue
 ** module id = 16
 ** module chunks = 0
 **/